import axios from 'axios';
import { AppDispatch, store } from '../../store';
import {
  Appointment_interface,
  Appointment_server_interface,
} from '../../interfaces/Interfaces';
import {
  setAppointments,
  setLoadingAppointments,
} from '../../pages/Calendars/store/Appointment';
import { mapColor, usersMapColor } from '../../utility_objects/ColorManager';
import {
  getChiaveRichiestaAppuntamenti,
  getIntervalloRichiestaAppuntamenti,
} from '../../pages/Calendars/utility_objects/ChiaveRichiestaAppuntamenti';

interface fetchAppointmentsParams {
  selectedDate: Date;
  checkedServices: string[];
  checkedStudi: string[];
  checkedUsers: string[];
  checkedPointOfSales: string[];
  view?: string;
  externalCustomerCode?: string;
  email?: string;
  isTabClient?: boolean;
}

// Numero dell'ultima GetAll partita, da qualunque agenda: tutte scrivono la stessa
// lista, quindi la risposta di una richiesta superata da una partita dopo si scarta,
// errore compreso, e lista e caricamento restano a quella nuova.
let ultimaRichiesta = 0;

export const fetchAppointments = ({
  selectedDate,
  checkedServices: serviceIds,
  checkedStudi: studioIds,
  checkedUsers: userIds,
  checkedPointOfSales: pointOfSaleIds,
  view = 'Day',
  email = '',
  externalCustomerCode,
  isTabClient = false,
}: fetchAppointmentsParams) => {
  return async (dispatch: AppDispatch) => {
    const richiesta = ++ultimaRichiesta;
    const isSuperata = () => richiesta !== ultimaRichiesta;
    dispatch(setLoadingAppointments(true));
    const [startDate, endDate] = getIntervalloRichiestaAppuntamenti(
      selectedDate,
      view,
      isTabClient
    );
    // Salvata con la lista, anche vuota dopo un errore: la pagina sa così per
    // quale data e quali filtri è la lista che ha in mano
    const chiaveRichiesta = getChiaveRichiestaAppuntamenti({
      selectedDate,
      view,
      isTabClient,
      checkedServices: serviceIds,
      checkedStudi: studioIds,
      checkedUsers: userIds,
      checkedPointOfSales: pointOfSaleIds,
      email,
      externalCustomerCode,
    });
    const { loginData } = store.getState().bluBookingRoot;
    const { companyColorEnum: companyColor } = loginData ?? {};
    try {
      const {
        data: { data },
      } = await axios.post<{
        data: Appointment_server_interface[];
      }>(`/api/Appointment/GetAll?dc=${Date.now()}`, {
        startDate,
        endDate,
        serviceIds,
        studioIds,
        userIds,
        pointOfSaleIds,
        email: email !== '' ? email : undefined,
        externalCustomerCode,
      });
      // Superata da una richiesta partita dopo: lista e caricamento sono suoi
      if (isSuperata()) return;
      const result: Appointment_interface[] = data
        .map((element, index: number) => {
          let checkColor = element?.color;
          if (checkColor === null || checkColor === undefined) {
            if (companyColor) checkColor = usersMapColor[element.userId];
            else checkColor = mapColor[element.serviceId];
          }
          return {
            ...element,
            Id: element.id,
            Subject: `${element.surname || ''} ${element.name || ''} `,
            Location: 'Bludata S.r.l.',
            StartTime: element.startTime,
            EndTime: element.endTime,
            CategoryColor: index % 2 === 0 ? '#5e3c58' : '#009246',
            color: checkColor,
            isAllDay: false,
          };
        })
        .flat();
      dispatch(setAppointments({ appointments: result, chiaveRichiesta }));
      dispatch(setLoadingAppointments(false));
    } catch (error) {
      if (isSuperata()) return;
      console.error(error);
      dispatch(setAppointments({ appointments: [], chiaveRichiesta }));
      dispatch(setLoadingAppointments(false));
    }
  };
};
